import { Injectable } from '@angular/core';
import {
  ShiftResourceListParams,
  ShiftResourceTypePayload,
} from '@app/domain';
import {
  ShiftResourceElement,
  ShiftResourceTypeItem,
} from '@app/domain/entities/shift-resource.entity';
import { ShiftResourceRepository } from '@app/domain/repositories/shift-resource.repository';
import { PaginatedResponse } from '@app/shared/models/global.model';
import { Observable } from 'rxjs';
import { ShiftResourceService } from '../api-clients/shift-resource.service';

@Injectable()
export class ShiftResourceRepositoryImpl implements ShiftResourceRepository {
  constructor(private readonly _shiftResourceService: ShiftResourceService) {}

  getList(
    params: ShiftResourceListParams
  ): Observable<PaginatedResponse<ShiftResourceTypeItem>> {
    return this._shiftResourceService.listItems(params);
  }

  getClientCodes(): Observable<string[]> {
    return this._shiftResourceService.getClientCodes();
  }

  createType(
    body: ShiftResourceTypePayload
  ): Observable<ShiftResourceTypeItem> {
    return this._shiftResourceService.createType(body);
  }

  getDefaultInputFields(): Observable<ShiftResourceElement[]> {
    return this._shiftResourceService.getDefaultInputFields();
  }

  getType(id: number): Observable<ShiftResourceTypeItem> {
    return this._shiftResourceService.getType(id);
  }

  updateType(
    id: number,
    body: ShiftResourceTypePayload
  ): Observable<ShiftResourceTypeItem> {
    return this._shiftResourceService.updateType(id, body);
  }

  getVisibility(): Observable<{
    isNomVisible: boolean;
    isPsVisible: boolean;
    clientCodes: string[];
  }> {
    return this._shiftResourceService.getVisibility();
  }

  updateVisibility(body: {
    shouldShowNom: boolean;
    shouldShowPS: boolean;
    clientCodes: string[];
  }): Observable<void> {
    return this._shiftResourceService.updateVisibility(body);
  }

  reorderItems(ids: number[]): Observable<void> {
    return this._shiftResourceService.reorderItems(ids);
  }

  toggleStatus(id: number): Observable<void> {
    return this._shiftResourceService.toggleStatus(id);
  }
}
